interface ImagePair {
  sourceImage: string;
  resultImage: string;
}

interface Example {
  images: ImagePair[];
  title: string;
  description: string;
}

interface ImageToolShowcases {
  [key: string]: {
    title: string;
    description: string;
    examples: Example[];
  };
}

export const imageToolShowcases: ImageToolShowcases = {
  'oil-painting': {
    title: 'Transform Photos into Oil Paintings',
    description:
      'Convert ordinary photos into stunning oil painting masterpieces using our AI technology. Perfect for creating artistic renditions of portraits, landscapes, and more.',
    examples: [
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/f48bc352-0cd3-4a4d-85eb-b3e9b3cd2dff.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d2252f61-9d7a-4d78-a60c-c667b06578d5.png',
          },
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/0a80ea65-aace-4435-8d57-a952cfb8e6a0.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ca8b87ce-996f-4e15-afc4-2f611fc3d0ef.png',
          },
        ],
        title: 'Portrait to Oil Painting',
        description:
          'Transform portrait photos into classical (renaissance, baroque, etc.) oil painting style artwork, featuring rich textures and the timeless aesthetic of traditional painting.',
      },
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/4175ce27-5046-45fc-9f64-f913ebc37e90.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/24aba696-5377-491a-a3d2-68b4919d0f7e.png',
          },
        ],
        title: 'Landscape to Masterpiece',
        description:
          "Convert landscape photos into breathtaking oil painting scenes with vivid colors and artistic brush strokes that capture nature's beauty.",
      },
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/1352e4e8-1db0-4dc8-9c01-5e6c395aa528.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a117b900-360e-46b2-936c-0d9c7c30d12a.png',
          },
        ],
        title: 'Pet Portrait Transformation',
        description:
          'Transform photos of your beloved pets (dogs, cats) into charming oil paintings that capture their personality and spirit, perfect for pet lovers and unique home decor.',
      },
    ],
  },
  cartoon: {
    title: 'Turn Photos into Fun Cartoons',
    description:
      'Transform your photos into playful cartoon-style images with our AI technology. Perfect for social media, creating fun profile pictures, or memorable gifts.',
    examples: [
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/f48bc352-0cd3-4a4d-85eb-b3e9b3cd2dff.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/589d4c98-7cad-4152-a434-b468191757fa.png',
          },
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/f48bc352-0cd3-4a4d-85eb-b3e9b3cd2dff.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/00e821a1-d585-4905-861b-3380553c0d74.png',
          },
        ],
        title: 'Portrait to Cartoon Character',
        description:
          'Convert portrait photos into charming cartoon characters with expressive features and a playful style perfect for social media profiles.',
      },
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/1352e4e8-1db0-4dc8-9c01-5e6c395aa528.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5fa102cb-cf2e-4f07-9290-d5479f2842a0.png',
          },
        ],
        title: 'Pet Cartoonification',
        description:
          'Transform photos of pets into adorable cartoon characters that capture their personality with a fun, animated style.',
      },
      {
        images: [
          {
            sourceImage: 'https://media.easy-peasy.ai/static/IMG_2863.jpeg',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c7f6936b-13dd-4d34-90ec-c9ae334b4295.png',
          },
        ],
        title: 'Family Cartoon Creation',
        description:
          'Turn family photos into delightful cartoon scenes that preserve memories in a fun, artistic style - perfect for personalized gifts or decorations.',
      },
    ],
  },
  watercolor: {
    title: 'Turn Photos into Beautiful Watercolor Art',
    description:
      'Convert your photos into stunning watercolor art with our AI technology. Perfect for creating unique and artistic portraits, landscapes, and more.',
    examples: [
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/f48bc352-0cd3-4a4d-85eb-b3e9b3cd2dff.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/31df5db5-ebf7-46bb-a9cd-1c980f7a9f55.png',
          },
        ],
        title: 'Portrait to Watercolor',
        description:
          'Convert portrait photos into beautiful watercolor art that captures the essence of the subject with a delicate, artistic style.',
      },
    ],
  },
  sketch: {
    title: 'Turn Photos into Pencil Sketches',
    description:
      'Convert your photos into stunning pencil sketches with our AI technology. Perfect for creating unique and artistic portraits, landscapes, and more.',
    examples: [
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/f48bc352-0cd3-4a4d-85eb-b3e9b3cd2dff.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a00d147c-b9bb-4313-833a-e3e2b2691737.png',
          },
        ],
        title: 'Portrait to Pencil Sketch',
        description:
          'Convert portrait photos into beautiful pencil sketches that capture the essence of the subject with a delicate, artistic style.',
      },
    ],
  },
  'coloring-page': {
    title: 'Turn Photos into Coloring Pages',
    description:
      'Convert your photos into coloring pages with our AI technology. Perfect for creating unique and artistic portraits, landscapes, and more.',
    examples: [
      {
        images: [
          {
            sourceImage: 'https://media.easy-peasy.ai/static/IMG_2863.jpeg',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/43fa1f5b-f862-47a8-8e29-b1b17b889e3c.png',
          },
        ],
        title: 'Portrait to Coloring Page',
        description:
          'Convert portrait photos into coloring pages that capture the essence of the subject with a fun, artistic style.',
      },
      {
        images: [
          {
            sourceImage:
              'https://media.easy-peasy.ai/static/1352e4e8-1db0-4dc8-9c01-5e6c395aa528.png',
            resultImage:
              'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/39867dda-46b6-444f-a705-3d19516133b3.png',
          },
        ],
        title: 'Pet to Coloring Page',
        description:
          'Convert pet photos into coloring pages that capture the essence of your furry friends with a fun, artistic style.',
      },
    ],
  },
};
